import * as Immutable from 'immutable';
import { handleActions } from 'redux-actions';

import { CompetitionsActionType, CompetitionsStoreElement } from './CompetitionsReducer.types';

export const allSchema = [
  { label: 'competitionMenu.table.competition', id: ['name'], alignment: 'left' },
  { label: 'competitionMenu.table.status', id: ['status'], alignment: 'left' },
  { label: null, id: ['leaderboard', 'rank'], alignment: 'left' },
  { label: 'competitionMenu.table.startDate', id: ['startDate'], alignment: 'left' },
  { label: 'competitionMenu.table.endDate', id: ['endDate'], alignment: 'left' },
];

//todo: move all ui string to data.ts
export const prizesSchema = [
  {
    name: 'Criteria',
    id: 'criteria',
    active: true,
    type: 'string',
  },
  {
    name: 'Week',
    id: 'startDate',
    active: true,
    type: 'string',
  },
  {
    name: 'Team',
    id: 'team',
    active: true,
    type: 'string',
  },
  {
    name: 'Members',
    id: 'members',
    active: true,
    type: 'field',
  },
  {
    name: 'Country / Region',
    id: 'country',
    active: true,
    type: 'string',
  },
  {
    name: 'Rank',
    id: 'rank',
    active: true,
    type: 'number',
  },
  {
    name: 'Amount',
    id: 'value',
    active: true,
    type: 'number',
  },
];

export const referralsSchema = [
  {
    name: 'Rank',
    id: 'rank',
    active: true,
    type: 'integer',
  },
  {
    name: 'User',
    id: 'user',
    active: true,
    type: 'string',
  },
  {
    name: 'Registered Referees',
    id: 'registeredReferrals',
    active: true,
    type: 'integer',
  },
  {
    name: 'Consultant Referees',
    id: 'consultantReferrals',
    active: true,
    type: 'integer',
  },
  {
    name: 'Completed Referees',
    id: 'completedReferrals',
    active: true,
    type: 'integer',
  },
  {
    name: 'University',
    id: 'university',
    active: true,
    type: 'choice',
  },
  {
    name: 'Country / Region',
    id: 'country',
    active: true,
    type: 'choice',
  },
];

// @ts-ignore
const initialState: CompetitionsStoreElement = Immutable.fromJS({
  selectedColumns: null,
  selectedColumnsModal: null,
  fetchAgreeWithGuidelines: false,
  fetchUserCompetitions: false,
  userCompetitions: null,
  logoutCompetition: null,
  hideAgreementModal: true,
  allSchema,
  modalTableData: {
    count: null,
    next: null,
    previous: null,
    results: [],
  },
  consultant: {
    leader: {
      count: 0,
      next: null,
      previous: null,
      results: [],
    },
  },
  isFetching: false,
  tableCompetitions: {
    count: 0,
    next: null,
    previous: null,
    results: [],
  },
  tablePrizes: {
    count: 0,
    next: null,
    previous: null,
    results: [],
  },
  tableReferrals: {
    count: 0,
    next: null,
    previous: null,
    results: [],
  },
  tablePowerPool: {
    count: 0,
    next: null,
    previous: null,
    results: [],
  },
  fetchTableCompetitions: false,
  fetchGuidelines: false,
  guidelines: null,
  currentCompetition: '',
  options: null,
  showGuidelinesModal: false,
  countryOptions: null,
  levelOptions: null,
  fetchOptions: false,
  fetchOptionsId: '',
  fetchOptionsType: '',
});

const getColumnsCompetitions = ({ aggregationChoices, aggregation, options, aggregationDefault }: any) => {
  const currentAggregationChoice = aggregationChoices.find((choice: any) => choice.get('value') === aggregation);
  const columns = currentAggregationChoice.getIn(['properties', 0]).map((key: string) =>
    Immutable.fromJS({
      name: options.getIn([key, 'label']),
      id: key,
      active: true,
      type: options.getIn([key, 'type']),
      description: options.getIn([key, 'description']),
    })
  );

  if (aggregationDefault === aggregation) {
    return columns;
  } else {
    const name = aggregationChoices && aggregationChoices.getIn([0, 'label']);

    return columns.insert(
      0,
      Immutable.fromJS({
        id: 'usersLeaderboardLink',
        name: name ? `${name}s` : 'Users',
        active: true,
        type: 'number',
      })
    );
  }
};

const CompetitionsReducer: any = handleActions(
  {
    RESPONSE_CONSULTANT_LEADERBOARD_COMPETITIONS: (state: CompetitionsStoreElement, action: CompetitionsActionType) =>
      state.setIn(['consultant', action.payload.consultantType], Immutable.fromJS(action.payload.data)).set('isFetching', false),

    CLEAR_CONSULTANT_LEADERBOARD_COMPETITIONS: (state: CompetitionsStoreElement) =>
      state.setIn(
        ['consultant', 'leader'],
        Immutable.fromJS({
          count: 0,
          next: null,
          previous: null,
          results: [],
        })
      ),

    REQUEST_CONSULTANT_LEADERBOARD_COMPETITIONS: (state: CompetitionsStoreElement) => state.set('isFetching', true),

    RESPONSE_CONSULTANT_LEADERBOARD_MODAL_COMPETITIONS: (state: CompetitionsStoreElement, action: CompetitionsActionType) =>
      state.set('modalTableData', Immutable.fromJS(action.payload)).set('isFetching', false),

    REQUEST_USER_COMPETITIONS: (state: CompetitionsStoreElement, action: CompetitionsActionType) =>
      state.merge(
        Immutable.fromJS(
          Immutable.fromJS({
            fetchUserCompetitions: action.payload ? true : false,
          })
        )
      ),

    CLEAR_CONSULTANT_LEADERBOARD_MODAL_COMPETITIONS: (state: CompetitionsStoreElement) =>
      state.merge(
        Immutable.fromJS({
          modalTableData: {
            count: null,
            next: null,
            previous: null,
            results: [],
          },
        })
      ),

    USER_COMPETITIONS_SUCCESS: (state: CompetitionsStoreElement, action: CompetitionsActionType) =>
      state.merge(
        Immutable.fromJS({
          fetchUserCompetitions: false,
          userCompetitions: Immutable.fromJS(action.payload),
        })
      ),
    USER_COMPETITIONS_FAILURE: (state: CompetitionsStoreElement) =>
      state.merge(
        Immutable.fromJS({
          fetchUserCompetitions: false,
          isFetching: false,
        })
      ),
    COMPETITIONS_TABLE_SUCCESS: (state: CompetitionsStoreElement, action: CompetitionsActionType) =>
      state.set('fetchTableCompetitions', false).set('tableCompetitions', Immutable.fromJS(action.payload)),
    PRIZES_TABLE_SUCCESS: (state: CompetitionsStoreElement, action: CompetitionsActionType) =>
      state.set('fetchPrizesTable', false).set('tablePrizes', Immutable.fromJS(action.payload)),
    REQUEST_REFERRALS_TABLE: (state: CompetitionsStoreElement) => state.set('fetchReferralsTable', true),
    REFERRALS_TABLE_FAILURE: (state: CompetitionsStoreElement, action: CompetitionsActionType) => state.set('fetchReferralsTable', false),
    REFERRALS_TABLE_MODAL_SUCCESS: (state: CompetitionsStoreElement, action: CompetitionsActionType) =>
      state.set('fetchReferralsTable', false),
    REFERRALS_TABLE_SUCCESS: (state: CompetitionsStoreElement, action: CompetitionsActionType) =>
      state.set('fetchReferralsTable', false).set('tableReferrals', Immutable.fromJS(action.payload)),
    REQUEST_POWER_POOL_TABLE: (state: CompetitionsStoreElement) => state.set('fetchPowerPoolTable', true),
    POWER_POOL_TABLE_FAILURE: (state: CompetitionsStoreElement, action: CompetitionsActionType) => state.set('fetchPowerPoolTable', false),
    POWER_POOL_TABLE_MODAL_SUCCESS: (state: CompetitionsStoreElement, action: CompetitionsActionType) =>
      state.set('fetchPowerPoolTable', false),
    POWER_POOL_TABLE_SUCCESS: (state: CompetitionsStoreElement, action: CompetitionsActionType) =>
      state.set('fetchPowerPoolTable', false).set('tablePowerPool', Immutable.fromJS(action.payload)),
    REQUEST_SPC_LEADERBOARD_TABLE: (state: CompetitionsStoreElement) => state.set('fetchSpcLeaderboardTable', true),
    SPC_LEADERBOARD_TABLE_FAILURE: (state: CompetitionsStoreElement) => state.set('fetchSpcLeaderboardTable', false),
    SPC_LEADERBOARD_TABLE_MODAL_SUCCESS: (state: CompetitionsStoreElement) => state.set('fetchSpcLeaderboardTable', false),
    SPC_LEADERBOARD_TABLE_SUCCESS: (state: CompetitionsStoreElement, action: CompetitionsActionType) =>
      state.set('fetchSpcLeaderboardTable', false).set('tableSpcLeaderboard', Immutable.fromJS(action.payload)),
    REQUEST_COMPETITIONS_TABLE: (state: CompetitionsStoreElement) => state.set('fetchTableCompetitions', true),
    COMPETITIONS_TABLE_FAILURE: (state: CompetitionsStoreElement) => state.set('fetchTableCompetitions', false),
    REQUEST_COMPETITION_ACCEPT_AGREEMENT: (state: CompetitionsStoreElement) => state.set('fetchAgreeWithGuidelines', false),
    RESPONSE_COMPETITION_ACCEPT_AGREEMENT_FAILURE: (state: CompetitionsStoreElement) => state.set('fetchTableCompetitions', false),
    RESPONSE_COMPETITION_ACCEPT_AGREEMENT_SUCCESS: (state: CompetitionsStoreElement) => state.set('fetchTableCompetitions', false),
    REQUEST_COMPETITION_AGREEMENT: (state: CompetitionsStoreElement) => state.set('fetchGuidelines', true),
    RESPONSE_COMPETITION_AGREEMENT_FAILURE: (state: CompetitionsStoreElement) => state.set('fetchGuidelines', false),
    RESPONSE_COMPETITION_AGREEMENT_SUCCESS: (state: CompetitionsStoreElement, action: CompetitionsActionType) =>
      state.set('fetchGuidelines', false).set('guidelines', Immutable.fromJS(action.payload)),
    AUTHENTICATION_LOGOUT: () => initialState,
    CHANGE_CURRENT_COMPETITION: (state: CompetitionsStoreElement, action: CompetitionsActionType) =>
      state.set('currentCompetition', action.payload).set(
        'tableCompetitions',
        Immutable.fromJS({
          count: 0,
          next: null,
          previous: null,
          results: [],
        })
      ),
    REQUEST_COMPETITION_FILTERS: (state: CompetitionsStoreElement, action: CompetitionsActionType) => {
      return state
        .set('fetchOptions', true)
        .set('fetchOptionsId', action.payload.competitionId)
        .set('fetchOptionsType', action.payload.competitionType);
    },
    RESPONSE_COMPETITION_FILTERS_SUCCESS: (state: CompetitionsStoreElement, action: CompetitionsActionType) => {
      const { __modalLeaderboardOptions: modalTableOptions, aggregate, ...allColumnsForCurrentTable } = action.payload;

      const countryOptions: Record<string, string> = {};
      const countryChoices = action.payload.country && action.payload.country.choices;
      if (countryChoices) {
        countryChoices.forEach((country: any) => {
          countryOptions[country.value] = country.label;
        });
      }

      const universityCountryOptions: Record<string, string> = {};
      const universityCountryChoices = action.payload.universityCountry && action.payload.universityCountry.choices;
      if (universityCountryChoices) {
        universityCountryChoices.forEach((country: any) => {
          universityCountryOptions[country.value] = country.label;
        });
      }

      const levelOptions: any = {};
      if (action.payload.level && action.payload.level.choices) {
        action.payload.level.choices.map((level: any) => {
          levelOptions[level.value] = level.label;
        });
      }
      const options = Immutable.fromJS(allColumnsForCurrentTable);

      const initialAggregation = aggregate.choices.find((choice: any) => !choice.isDisabled).value;
      const columns = getColumnsCompetitions({
        options,
        aggregation: initialAggregation,
        aggregationChoices: Immutable.fromJS(aggregate.choices),
        aggregationDefault: aggregate.choices[0].value,
      });

      let modalColumns = columns;

      // Allow columns in modal leaderboard using custom columns definition instead of the definition of
      // default aggregation of the main leaderboard options
      if (modalTableOptions) {
        const { aggregate: modalAggregate, ...modalTableColumns } = modalTableOptions;
        const modalColumnsSchema = Immutable.fromJS(modalTableColumns);
        modalColumns = modalAggregate.choices[0].properties[0].map((key: string) =>
          Immutable.fromJS({
            id: key,
            active: true,
            type: modalColumnsSchema.getIn([key, 'type']),
            name: modalColumnsSchema.getIn([key, 'label']),
            description: modalColumnsSchema.getIn([key, 'description']),
          })
        );
      }

      return state
        .set('options', options)
        .set('modalTableOptions', Immutable.fromJS(modalTableOptions))
        .set('countryOptions', Immutable.fromJS(countryOptions))
        .set('universityCountryOptions', Immutable.fromJS(universityCountryOptions))
        .set('levelOptions', Immutable.fromJS(levelOptions))
        .set('aggregationChoices', Immutable.fromJS(aggregate.choices))
        .set('aggregation', Immutable.fromJS(initialAggregation))
        .set('selectedColumns', Immutable.fromJS(columns))
        .set('selectedColumnsModal', Immutable.fromJS(modalColumns))
        .set('fetchOptions', false);
    },

    RESPONSE_COMPETITION_FILTERS_CANCEL: (state: CompetitionsStoreElement) => {
      return state.set('fetchOptions', false);
    },
    CHANGE_COMPETITION_TAB: (state: CompetitionsStoreElement, action: CompetitionsActionType) => {
      // @ts-ignore
      if (action.payload === 'prize') {
        return state.set('selectedColumns', Immutable.fromJS(prizesSchema));
      } // @ts-ignore
      else if (action.payload === 'referrals') {
        //todo: use BE schema only
        return state.set('selectedColumns', Immutable.fromJS(referralsSchema));
      } else {
        const aggregationChoices = state.get('aggregationChoices');
        const options = state.get('options');
        if (!aggregationChoices || !options) {
          return state;
        }
        const aggregation = state.get('aggregation');
        const aggregationDefault = state.getIn(['aggregationChoices', 0, 'value']);
        const columns = getColumnsCompetitions({ aggregationChoices, aggregation, options, aggregationDefault });

        return state.set('selectedColumns', Immutable.fromJS(columns));
      }
    },
    CHANGE_AGGREGATION: (state: CompetitionsStoreElement, action: CompetitionsActionType) => {
      const aggregationDefault = state.getIn(['aggregationChoices', 0, 'value']);
      const aggregationChoices = state.get('aggregationChoices');
      const aggregation = action.payload;
      const options = state.get('options');
      const columns = getColumnsCompetitions({ aggregationChoices, aggregation, options, aggregationDefault });
      if (aggregationDefault === action.payload) {
        return state
          .set('selectedColumns', Immutable.fromJS(columns))
          .set('selectedColumnsModal', Immutable.fromJS(columns))
          .set('aggregation', action.payload);
      } else {
        return state.set('selectedColumns', Immutable.fromJS(columns)).set('aggregation', action.payload);
      }
    },
    RESPONSE_COMPETITION_FILTERS_FAILURE: (state: CompetitionsStoreElement) => state.set('fetchOptions', false),
    TOGGLE_GUIDELINES_MODAL: (state: CompetitionsStoreElement, action: CompetitionsActionType) =>
      state.set('showGuidelinesModal', action.payload),
    REQUEST_ALL_COMPETITIONS: (state: CompetitionsStoreElement) => state.set('fetchAllCompetitions', true),
    RESPONSE_ALL_COMPETITIONS_FAILURE: (state: CompetitionsStoreElement) =>
      state.set('fetchAllCompetitions', false).set('allCompetitions', null),
    RESPONSE_ALL_COMPETITIONS_SUCCESS: (state: CompetitionsStoreElement, action: CompetitionsActionType) =>
      state.set('fetchAllCompetitions', false).set('allCompetitions', Immutable.fromJS(action.payload)),
    REQUEST_COMPETITION: (state: CompetitionsStoreElement) => state.set('fetchCompetition', true),
    CLEAN_COMPETITION: (state: CompetitionsStoreElement) => state.set('competition', null),
    RESPONSE_COMPETITION_FAILURE: (state: CompetitionsStoreElement) => state.set('fetchCompetition', false).set('competition', null),
    RESPONSE_COMPETITION_SUCCESS: (state: CompetitionsStoreElement, action: CompetitionsActionType) => {
      const currentCompetition = Immutable.fromJS(action.payload.json);

      return state.set('fetchCompetition', false).set('competition', currentCompetition);
    },
    HIDE_AGREEMENTS_COMPETITIONS: (state: CompetitionsStoreElement) => state.set('hideAgreementModal', false),
    SET_LOGOUT_COMPETITION: (state: CompetitionsStoreElement, action: CompetitionsActionType) =>
      state.set('logoutCompetition', action.payload),
  },
  initialState
);

export default CompetitionsReducer;
